import { cn } from "@/shared/lib/utils";
import type { DeficiencySeverity } from "./deficiencyHelpers";

export function PriorityDot({ priority }: { priority: DeficiencySeverity }) {
  const colors = {
    critical: "bg-red-500 shadow-red-500/50",
    high: "bg-orange-500 shadow-orange-500/50",
    medium: "bg-amber-500 shadow-amber-500/50",
    low: "bg-slate-500 shadow-slate-500/50",
  };
  return <span className={cn("inline-block w-2.5 h-2.5 rounded-full shadow-[0_0_5px_1px] shrink-0", colors[priority])} />;
}
